import { Button, PageLayout } from "@ezmid/components-library";
import { faPlus } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router";

import { makeRoute } from "../../../hooks/route";
import { AllRoutes } from "../../route/Route";
import { CoursesListPageContent } from "../organisms/CoursesListPageContent";

export function CoursesListPage() {
  const { t } = useTranslation();

  const navigate = useNavigate();

  return (
    <PageLayout
      title={t("app.page.courses.heading")}
      navigation={
        <div className="mr-2 ">
          <Button
            onClick={() => {
              navigate(makeRoute(AllRoutes.COURSES_ADD));
            }}
            leftIcon={<FontAwesomeIcon icon={faPlus} />}
          >
            {t("button.createNew")}
          </Button>
        </div>
      }
    >
      <CoursesListPageContent />
    </PageLayout>
  );
}
